import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=4697cfa4&scoped=true"
import script from "./EventPopup.vue?vue&type=script&lang=js"
export * from "./EventPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697cfa4",
  null
  
)

export default component.exports